<template>
    <div :class="['nong-about-box',isIosShow?'nong-bottom':'']">
        <div class="nong-box-cover"></div>
        <!--        <v-container>-->
        <div class="nong-news-container">
            <v-row no-gutters>
                <v-col cols="12">
                    <div class="nong-news-title">
                        {{ $t('message.news') }}
                    </div>
                </v-col>
            </v-row>
            <div class="nong-news-boxs">
                <v-row
                        v-for="(newTitle,i) in news"
                        :key="i"
                        no-gutters
                        class="nong-news-text"
                        justify="center"
                        align="start"
                >
                    <v-col cols="12"
                           md="2"
                           lg="2"
                           xl="2"
                           ms="12"
                    >
                        <div class="nong-news-text-time">{{Object.keys(newTitle)[0]}}</div>
                    </v-col>
                    <v-col cols="12"
                           md="10"
                           lg="10"
                           xl="10"
                           ms="12"
                    >
                        <v-row
                                v-for="(newList,index) in newTitle[Object.keys(newTitle)[0]]"
                                :key="index"
                                no-gutters
                                justify="center"
                                align="center"
                                class="nong-news-list"
                        >
                            <v-col cols="12"
                                   md="6"
                                   lg="6"
                                   xl="6"
                                   ms="12">
                                <a :href="newList.linkUrl">
                                    <div class="nong-news-list-title">
                                        {{getItem=='cn'?newList.tips:newList.enTips}} |
                                        {{getItem=='cn'?newList.name:newList.enName}}
                                    </div>
                                </a>
                            </v-col>
                            <v-col cols="12"
                                   md="6"
                                   lg="6"
                                   xl="6"
                                   ms="12">
                                <a :href="newList.linkUrl">
                                    <div :class="getItem=='cn'?'nong-news-list-contact-cn':''">
                                        {{getItem=='cn'?newList.place:newList.enPlace}}
                                    </div>
                                </a>
                            </v-col>
                        </v-row>
                    </v-col
                    >
                </v-row>
            </div>

            <!--        </v-container>-->
        </div>
    </div>
</template>

<script>
import {webNewsList} from "../../api/home";

export default {
  name: "news",
  data() {
    return {
      isIosShow: false,
      getItem: 'cn',
      news: []
    }
  },
  created() {
    this.initData()
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      this.isIosShow = true
    } else {
      this.isIosShow = false
    }
  },
  methods: {
    initData() {
      webNewsList().then(res => {
        // window.console.log(localStorage.getItem('locale'))
        if (res.errcode == 0) {
          // window.console.log(res.data[1])
          if (localStorage.getItem('locale') == 'zh-CN') {
            this.getItem = 'cn'
          } else {
            this.getItem = 'en'
          }
          this.news = res.data
        } else {
          window.console.log(res)
        }
      }).catch(err => {
        window.console.log(err)
      });
    }
  }
}
</script>

<style>
    @media screen and (min-width: 960px) {
        .nong-news-box {
            width: 100%;
            height: 100%;
            padding-top: 48px;
            box-sizing: border-box;
        }

        .nong-news-boxs {
            width: 100%;
            height: calc(100% - 80px);
            display: flex;
            /*justify-content: center;*/
            flex-direction: column;
            overflow-y: auto;
        }

        .nong-news-boxs::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
        }

        .nong-news-boxs::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #535353;
        }

        .nong-news-boxs::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            background: #ededed;
        }

        .nong-about-box {
            width: 100%;
            height: 100%;
        }

        .nong-news-container {
            width: 100%;
            height: 100%;
            padding: 20px 100px 100px 100px;
            box-sizing: border-box;
        }

        .nong-news-title {
            color: white;
            width: 100%;
            font-size: 25px;
            /*margin-top: 10px;*/
            text-align: center;
            margin-bottom: 40px;
        }

        .nong-news-text {
            margin-top: 40px;
            color: white;
            font-size: 11px;
            font-weight: 300;
        }

        .nong-news-text-time {
            font-size: 18px;
            line-height: 24px;
            font-family: Montserrat;
            font-weight: 500;
        }

        .nong-news-list {
            padding-bottom: 10px;
        }

        .nong-news-list div a {
            color: white;
            text-decoration: none;
        }

        .nong-news-list-title {
            width: 330px;
        }

        /*.row {*/
        /*    display: -webkit-box;*/
        /*}*/
    }

    @media screen and (max-width: 960px) {
        .nong-news-box {
            width: 100%;
            /*height: 100%;*/
            padding-top: 48px;
            box-sizing: border-box;
        }

        .nong-news-boxs {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
        }

        .nong-news-boxs::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
        }

        .nong-news-boxs::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #535353;
        }

        .nong-news-boxs::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            background: #ededed;
        }

        .nong-news-container {
            padding: 20px 25px;
        }

        .nong-news-title {
            color: white;
            width: 100%;
            font-size: 20px;
            /*margin-top: 10px;*/
            text-align: center;
            /*margin-bottom: 40px;*/
        }

        .nong-news-text {
            margin-top: 40px;
            color: white;
            font-size: 11px;
            font-weight: 300;
        }

        .nong-news-text-time {
            font-size: 18px;
            line-height: 24px;
            font-family: Montserrat;
            font-weight: 500;
            text-align: left;
            margin-bottom: 16px;
        }

        .nong-news-list {
            padding-bottom: 10px;
            font-size: 12px;
            font-weight: 300;
        }

        .nong-news-list div a {
            /*color: white;*/
            color: rgba(128, 128, 128, 1);
            text-decoration: none;
        }

        .nong-news-list-title {
            width: 330px;
            color: white;
        }

        /*.row {*/
        /*    display: -webkit-box;*/
        /*}*/
        .nong-news-list-contact-cn {
            padding-left: 30px;
        }

        .nong-box-cover {
            width: 98%;
            height: 60px;
            position: absolute;
            background-color: black;
            top: 0;
            left: 0;
        }

        .nong-bottom {
            padding-bottom: 60px;
        }
    }
</style>
